<template>
  <el-card shadow="never" class="bg-music-container">
    <div class="header">
      <div class="header-left">
        <div class="cover" @click="playAudio">
          <el-image :class="{ 'rotating': isPlaying }" :src="require('@/assets/images/music.png')"
            fit="contain"></el-image>
          <div v-if="row.bgmUrl" class="cover-shade">
            <svgIcon :iconClass="isPlaying ? 'pusewhite' : 'play'" width="16px" height="16px" />
          </div>
        </div>
        <div class="header-name">
          <div class="title">{{ row.bgmUrlName || title }}</div>
          <div class="subtitle">{{ subtitle }}</div>
        </div>
      </div>
      <div class="header-right" @click="bgMusicDialog = true">
        <el-icon>
          <ArrowRight />
        </el-icon>
      </div>
    </div>
    <div v-if="row.bgmUrl" class="controls">
      <div class="control">
        <label>音量</label>
        <el-slider v-model="row.bgmVolume" size="small" :step="0.1" :min="0" :max="1" />
      </div>
    </div>

    <div v-if="row.bgmUrl" style="text-align: right;">
      <el-button type="danger" :icon="Close" circle size="small"
        @click="row.bgmUrl = '', row.musicId = '', row.bgmUrlName = '', pause()" />
    </div>
    <slot></slot>
    <!-- 音频 -->
    <el-dialog v-model="bgMusicDialog" title="音频资源" top="25px" width="85%" center :show-close="true"
      :close-on-click-modal="false">
      <bg-music-stash ref="bgMsicStashRef" />
      <div style="text-align: right;margin-top: 20px;">
        <el-button size="large" @click="bgMusicDialog = false">取消</el-button>
        <el-button type="primary" size="large" @click="bgMusicSubmitFn(bgMsicStashRef)">确定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { Close, } from '@element-plus/icons-vue'
import { useAudioPlayer } from '@/hooks/useAudioPlayer.ts';
import bgMusicStash from '@/views/newVideo/components/right/bgMusicStash/index.vue'
const emits = defineEmits([
  'clickArrowRightFn'
]);

const props = defineProps({
  title: {
    type: String,
    default: '背景音乐'
  },
  subtitle: {
    type: String,
    default: ''
  },
  row: {
    type: Object,
    default: () => ({})
  }
})
const { isPlaying, toggle, setVolume, pause } = useAudioPlayer();

let bgMusicDialog = ref(false)
let bgMsicStashRef = ref(null)

watch(() => props.row.bgmUrl, (newValue, oldValue) => {
  pause()
}, { deep: true })

watch(() => props.row.bgmVolume, (bgmVolume) => {
  setVolume(bgmVolume)
}, { immediate: true, })


let bgMusicSubmitFn = (refs) => {
  let obj = refs.getRowMusicFn()
  props.row.bgmUrl = obj.value
  props.row.bgmUrlName = obj.label
  props.row.musicId = obj.id
  props.row.bgmVolume = obj.bgmVolume || 0.5
  bgMusicDialog.value = false
}

const playAudio = () => {
  // 添加播放音频的逻辑
  if (props.row.bgmUrl) toggle(props.row.bgmUrl);
}
</script>

<style scoped lang="scss">
.bg-music-container {
  max-width: 320px;
  margin: 20px auto;
  border-radius: 12px;
  background: #f9fafb;
  color: #333;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  :deep() {
    .el-card__body {
      padding: 10px 15px;
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header-left {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;

    .cover {
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      transition: transform 0.5s ease;
      margin-right: 15px;
      padding: 5px;
      border: 3px solid #5754f9;
      border-radius: 50%;
      cursor: pointer;
      position: relative;
      flex-shrink: 0;
    }

    .header-name {
      flex: 1;
      overflow: hidden;
    }

    .cover-shade {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.7;
    }

    .rotating {
      animation: rotate 2s linear infinite;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      color: #5754f9;
      font-weight: bold;
    }
  }
}



.title {
  font-weight: bold;
  color: #5754f9;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.subtitle {
  color: #888888;
  font-size: 14px;
}

.controls {
  margin-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.control {
  margin: 15px 0;
}

.control label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #666666;
}

.play-button {
  background-color: #5754f9;
  border-color: #5754f9;
  transition: background-color 0.3s, border-color 0.3s;

  &:hover {
    background-color: #4845e6;
    border-color: #4845e6;
  }
}
</style>
